"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ErrorDocument_1 = require("./_ErrorDocument");
var _IndexDocument_1 = require("./_IndexDocument");
var _RedirectAllRequestsTo_1 = require("./_RedirectAllRequestsTo");
var _RoutingRules_1 = require("./_RoutingRules");
exports._WebsiteConfiguration = {
    type: "structure",
    required: [],
    members: {
        ErrorDocument: {
            shape: _ErrorDocument_1._ErrorDocument
        },
        IndexDocument: {
            shape: _IndexDocument_1._IndexDocument
        },
        RedirectAllRequestsTo: {
            shape: _RedirectAllRequestsTo_1._RedirectAllRequestsTo
        },
        RoutingRules: {
            shape: _RoutingRules_1._RoutingRules
        }
    }
};
//# sourceMappingURL=_WebsiteConfiguration.js.map